import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * @param {object} props
 * @param {Function} props.onClick
 * @param {string} [props.title]
 * @param {'legacy' | 'default' | 'big-top' | 'pathway-ink'} [props.variant] - Skill chrome variants use compact lavender styling
 */
export default function YellowBackButton({ onClick, title, variant = 'legacy' }) {
  const label = title || 'Back';

  if (variant === 'default' || variant === 'big-top' || variant === 'pathway-ink') {
    const className = [
      'skill-back-btn',
      variant === 'big-top' && 'skill-back-btn--big-top',
      variant === 'pathway-ink' && 'skill-back-btn--pathway-ink',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <button
        type="button"
        className={className}
        onClick={onClick}
        title={label}
        aria-label={label}
      >
        <span className="skill-back-btn__arrow" aria-hidden="true">←</span>
      </button>
    );
  }

  return (
    <Button
      onClick={onClick}
      style={{
        marginTop: '10px',
        marginLeft: window.innerWidth < 576 ? '10px' : '20px',
        width: window.innerWidth < 576 ? '40px' : '55px',
        height: window.innerWidth < 576 ? '40px' : '55px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#FFD700',
        border: 'none',
        boxShadow: '0 4px 12px rgba(255, 215, 0, 0.3)',
        fontSize: '20px',
        color: '#333',
        zIndex: 1000,
        transition: 'all 0.3s ease',
      }}
      onMouseEnter={(e) => {
        e.target.style.transform = 'scale(1.1)';
        e.target.style.boxShadow = '0 6px 16px rgba(255, 215, 0, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = '0 4px 12px rgba(255, 215, 0, 0.3)';
      }}
      title={label}
    >
      ←
    </Button>
  );
}
